import { __decorate, __param } from 'tslib';
import { ElementRef, ChangeDetectorRef, Directive, Injectable, Pipe, Optional, SkipSelf, NgModule, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateDirective, TranslateService, TranslatePipe, TranslateModule, TranslateLoader, TranslateStore, TranslateCompiler, TranslateParser, MissingTranslationHandler, USE_DEFAULT_LANG, USE_STORE, USE_EXTEND, DEFAULT_LANGUAGE } from '@ngx-translate/core';
import { APP_PARAMETER } from '@wlp/ui-bs-parameter';

let UiBsTranslateDirective = class UiBsTranslateDirective extends TranslateDirective {
    constructor(uiBsTranslateService, uiBsElement, uiBsRef) {
        super(uiBsTranslateService, uiBsElement, uiBsRef);
        this.uiBsTranslateService = uiBsTranslateService;
        this.uiBsElement = uiBsElement;
        this.uiBsRef = uiBsRef;
    }
};
UiBsTranslateDirective.ctorParameters = () => [
    { type: TranslateService },
    { type: ElementRef },
    { type: ChangeDetectorRef }
];
UiBsTranslateDirective = __decorate([
    Directive({
        selector: '[ui-translate]'
    })
], UiBsTranslateDirective);

let UiBsTranslatePepi = class UiBsTranslatePepi extends TranslatePipe {
    constructor(uiBsTranslate, uiBsUiRef) {
        super(uiBsTranslate, uiBsUiRef);
        this.uiBsTranslate = uiBsTranslate;
        this.uiBsUiRef = uiBsUiRef;
    }
};
UiBsTranslatePepi.ctorParameters = () => [
    { type: TranslateService },
    { type: ChangeDetectorRef }
];
UiBsTranslatePepi = __decorate([
    Injectable(),
    Pipe({
        name: 'wlpTranslate',
        pure: false // required to update the value when the promise is resolved
    })
], UiBsTranslatePepi);

var UiBsTranslateModule_1;
let UiBsTranslateModule = UiBsTranslateModule_1 = class UiBsTranslateModule {
    constructor(parentModule) {
        //...
    }
    static forRoot(config) {
        return {
            ngModule: UiBsTranslateModule_1,
            providers: [
                { provide: APP_PARAMETER, useValue: config }
            ]
        };
    }
};
UiBsTranslateModule.ctorParameters = () => [
    { type: UiBsTranslateModule, decorators: [{ type: Optional }, { type: SkipSelf }] }
];
UiBsTranslateModule = UiBsTranslateModule_1 = __decorate([
    NgModule({
        declarations: [
            UiBsTranslateDirective,
            UiBsTranslatePepi,
        ],
        imports: [
            TranslateModule.forRoot({
                defaultLanguage: 'pt-br',
                loader: {
                    provide: TranslateLoader,
                    useFactory: HttpLoaderFactory,
                    deps: [HttpClient]
                }
            }),
        ],
        exports: [
            UiBsTranslateDirective,
            UiBsTranslatePepi,
        ]
    }),
    __param(0, Optional()), __param(0, SkipSelf())
], UiBsTranslateModule);
function HttpLoaderFactory(http) {
    return new TranslateHttpLoader(http);
}

let UiBsTranslateService = class UiBsTranslateService extends TranslateService {
    constructor(uiBsTranslateStore, uiBsTranslateLoader, uiBsTranslateCompiler, uiBsTranslateParser, uiBsMissingTranslationHandler, uiBsUseDefaultLang = true, uiBsIsolate = false, uiBsExtend = false, uiBsDefaultLanguage) {
        super(uiBsTranslateStore, uiBsTranslateLoader, uiBsTranslateCompiler, uiBsTranslateParser, uiBsMissingTranslationHandler, uiBsUseDefaultLang, uiBsIsolate, uiBsExtend, uiBsDefaultLanguage);
        this.uiBsTranslateStore = uiBsTranslateStore;
        this.uiBsTranslateLoader = uiBsTranslateLoader;
        this.uiBsTranslateCompiler = uiBsTranslateCompiler;
        this.uiBsTranslateParser = uiBsTranslateParser;
        this.uiBsMissingTranslationHandler = uiBsMissingTranslationHandler;
        this.uiBsUseDefaultLang = uiBsUseDefaultLang;
        this.uiBsIsolate = uiBsIsolate;
        this.uiBsExtend = uiBsExtend;
        if (uiBsDefaultLanguage) {
            this.setDefaultLang(uiBsDefaultLanguage);
        }
    }
};
UiBsTranslateService.ctorParameters = () => [
    { type: TranslateStore },
    { type: TranslateLoader },
    { type: TranslateCompiler },
    { type: TranslateParser },
    { type: MissingTranslationHandler },
    { type: Boolean, decorators: [{ type: Inject, args: [USE_DEFAULT_LANG,] }] },
    { type: Boolean, decorators: [{ type: Inject, args: [USE_STORE,] }] },
    { type: Boolean, decorators: [{ type: Inject, args: [USE_EXTEND,] }] },
    { type: String, decorators: [{ type: Inject, args: [DEFAULT_LANGUAGE,] }] }
];
UiBsTranslateService = __decorate([
    Injectable(),
    __param(5, Inject(USE_DEFAULT_LANG)),
    __param(6, Inject(USE_STORE)),
    __param(7, Inject(USE_EXTEND)),
    __param(8, Inject(DEFAULT_LANGUAGE))
], UiBsTranslateService);

/*
 * Public API Surface of ui-bs-translate
 */

/**
 * Generated bundle index. Do not edit.
 */

export { HttpLoaderFactory, UiBsTranslateDirective, UiBsTranslateModule, UiBsTranslatePepi, UiBsTranslateService };
//# sourceMappingURL=wlp-ui-bs-translate.js.map
